export default "/images/e2f521b601027293677a0d49135aa34e.avif";